import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import Button from 'styled/components/Button/Button';
import { redirectTo } from 'actions/redirect';
import useMartyContext from 'hooks/useMartyContext';
import { MAX_ALLOWED_IMAGE_SIZE_BYTES } from 'constants/visualSearch';
import { receiveVisualSearchInputImage } from 'actions/visualSearch';
import css from 'components/VisualSearch/SearchByPhoto/searchByPhoto.scss';

const SearchByPhoto = () => {
  const dispatch = useDispatch();

  const {
    marketplace: {
      reviews: { allowedImageTypes }
    }
  } = useMartyContext();

  const imageUploadButtonRef = useRef<HTMLInputElement | null>(null);
  const dropRef = useRef<HTMLDivElement | null>(null);
  const [inputImage, setInputImage] = useState<File | null>(null);

  const uploadFileClick = () => {
    imageUploadButtonRef.current?.click();
    setInputImage(null);
  };

  const checkSize = (file: File) => {
    const { size } = file;
    // todo - show alert for size exceed
    return size <= MAX_ALLOWED_IMAGE_SIZE_BYTES;
  };

  const onImageFileUploadChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = target;
    if (files?.length) {
      const inputFile = files[0];
      if (checkSize(inputFile!)) {
        setInputImage(inputFile!);
      }
    }
  };

  useEffect(() => {
    dropRef.current?.addEventListener('dragover', handleDragOver);
    dropRef.current?.addEventListener('drop', handleDrop);

    return () => {
      dropRef.current?.removeEventListener('dragover', handleDragOver);
      dropRef.current?.removeEventListener('drop', handleDrop);
    };
  }, []);

  const handleDragOver = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const { files } = e.dataTransfer!;
    if (files && files.length) {
      // todo - show alert for multiple files upload & invalid format
      const fileType = files[0]!.type.split('/')[1]; // 'image/png' => 'png'
      if (files.length > 1 || !allowedImageTypes.includes(fileType!)) {
        return;
      }

      const inputFile = files[0];
      if (checkSize(inputFile!)) {
        setInputImage(inputFile!);
      }
    }
  };

  useEffect(() => {
    if (inputImage) {
      dispatch(receiveVisualSearchInputImage(inputImage));
      dispatch(redirectTo('/visualSearch'));
    }
  }, [inputImage]);

  return (
    <div className={css.container}>
      <div className={css.imageContainer} ref={dropRef}>
        <span className={css.imageUploadContainer}>
          {/* todo add this once camera icon is added */}
          {/*<UtilityLargeStrokeCameraIcon />*/}
          <span>
            Drag an image here or
            <Button size="xsmall" variant="text" onClick={uploadFileClick}>
              Upload A File
            </Button>
            <input
              type="file"
              className={css.imageInput}
              onChange={onImageFileUploadChange}
              onClick={e => {
                (e.target as HTMLInputElement).value = '';
              }} // allow selecting same file again
              accept={allowedImageTypes}
              ref={imageUploadButtonRef}
              multiple={false}
            />
          </span>
        </span>
        <span className={css.dividerContainer}>
          <hr />
          Or
          <hr />
        </span>
        {/* todo - replace this by site redesign Input component */}
        <span>Image Search by link Coming Soon...</span>
      </div>
    </div>
  );
};

export default SearchByPhoto;
